export enum RoomStatus {
  Start = 'start',
  Finish = 'finish',
  Open = 'open',
  OpponentToStart = 'opponentToStart',
  OpponentToFinish = 'opponentToFinish',
  Cancelled = 'cancelled',
  Draw = 'draw',
  Lost = 'lost',
  Won = 'won',
  Processing = 'processing',
}

export enum RoomResultStatus {
  Expired,
  Game,
  InPlay,
  Result,
  Processing,
}
